// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern color scheme and variables */
:root {
  --primary: #2563eb;
  --primary-light: #60a5fa;
  --primary-dark: #1d4ed8;
  --gray-50: #f9fafb;
  --gray-100: #f3f4f6;
  --gray-200: #e5e7eb;
  --gray-700: #374151;
  --gray-800: #1f2937;
  --success: #22c55e;
  --warning: #f59e0b;
  --danger: #ef4444;
}

.dashboard-container {
  min-height: 100vh;
  background-color: var(--gray-50);
  display: flex;
  flex-direction: column;
}

/* Header */
.dashboard-header {
  background-color: white;
  padding: 1rem 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--gray-200);
}

.dashboard-header h1 {
  font-size: 1.5rem;
  color: var(--gray-800);
  margin: 0;
}

.logo-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #0d47a1;
  width: 70px;
  height: 70px;
  border-radius: 100rem;
}

.logo {
  position: relative;
  top: 2px;
  width: 60px;
  object-fit: contain;
  background: transparent;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.user-name {
  color: var(--gray-800);
  font-weight: 500;
}

.logout-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border: 1px solid var(--gray-200);
  border-radius: 6px;
  background-color: white;
  color: var(--gray-700);
  transition: all 0.2s;
}

.logout-button:hover {
  background-color: var(--gray-100);
}

/* Main Content */
.dashboard-content {
  flex: 1 1;
  max-width: 1280px;
  margin: 0 auto;
  padding: 2rem;
  width: 100%;
}

/* Welcome Section */
.welcome-section {
  background-color: white;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  border: 1px solid var(--gray-200);
}

.welcome-section h2 {
  color: var(--gray-800);
  margin-bottom: 0.5rem;
}

/* Dashboard Sections */
.dashboard-sections {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
}

.dashboard-section {
  background-color: white;
  border-radius: 8px;
  padding: 1.5rem;
  border: 1px solid var(--gray-200);
}

.section-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
}

.section-icon {
  color: var(--primary);
}

.section-header h3 {
  color: var(--gray-800);
  font-size: 1.25rem;
  font-weight: 600;
}

/* Action Cards */
.actions-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}

.action-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  border-radius: 8px;
  background-color: var(--gray-50);
  border: 1px solid var(--gray-200);
  text-decoration: none;
  color: var(--gray-800);
  transition: all 0.2s;
}

.action-card:hover {
  background-color: var(--gray-100);
}

.action-card.primary {
  background-color: var(--primary);
  color: white;
  border: none;
}

.action-card.primary:hover {
  background-color: var(--primary-dark);
}

.action-card.raw {
  background-color: var(--primary-light);
  color: white;
  border: none;
}

.action-card.raw:hover {
  background-color: var(--primary);
}

.action-icon {
  font-size: 1.5rem;
  margin-bottom: 0.75rem;
}

/* Messages */
.success-message {
  background-color: var(--success);
  color: white;
  padding: 0.75rem 1rem;
  border-radius: 6px;
  margin-bottom: 1rem;
}

.low-balance-alert {
  background-color: var(--danger);
  color: white;
  padding: 0.75rem 1rem;
  border-radius: 6px;
  margin-bottom: 1rem;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .dashboard-content {
    padding: 1.5rem;
  }
}

@media (max-width: 768px) {
  .dashboard-sections {
    grid-template-columns: 1fr;
  }
  
  .actions-grid {
    grid-template-columns: 1fr;
  }
  
  .dashboard-header {
    padding: 1rem;
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
  
  .user-info {
    flex-direction: column;
  }

  .logo {
    height: 40px;
  }
}

.rate-info-container {
  background-color: white;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  border: 1px solid var(--gray-200);
}

.rate-info-content {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.rate-section, .rate-type-section {
  background-color: var(--gray-50);
  border: 1px solid var(--gray-200);
  border-radius: 6px;
  padding: 1rem;
}

.rate-display, .rate-type-display {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.rate-display p, .rate-type-display p {
  margin: 0;
  font-weight: 500;
  color: var(--gray-800);
}

.rate-edit, .rate-type-edit {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.rate-input, .rate-type-select {
  padding: 0.5rem;
  border: 1px solid var(--gray-200);
  border-radius: 4px;
  width: 120px;
}

.edit-rate-button, .save-rate-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s;
}

.edit-rate-button {
  background-color: white;
  border: 1px solid var(--primary);
  color: var(--primary);
}

.edit-rate-button:hover {
  background-color: var(--gray-50);
}

.save-rate-button {
  background-color: var(--primary);
  border: none;
  color: white;
}

.save-rate-button:hover {
  background-color: var(--primary-dark);
}

.save-rate-button:disabled {
  background-color: var(--gray-200);
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .rate-edit, .rate-type-edit {
    flex-direction: column;
    align-items: stretch;
  }

  .rate-display, .rate-type-display {
    flex-direction: column;
    text-align: center;
    gap: 0.75rem;
  }
}

/* Footer */
.dashboard-footer {
  text-align: center;
  padding: 2rem;
  margin-top: auto;
  background-color: white;
  border-top: 1px solid var(--gray-200);
}

.dashboard-footer p {
  margin: 0;
  color: var(--gray-700);
  font-size: 0.9rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .dashboard-footer {
    padding: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,aAAa;EACb,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,iCAAiC;EACjC,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;AACnC;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,iCAAiC;EACjC,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,aAAa;AACb;EACE,gCAAgC;EAChC,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;EACd;AACF;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["/* Modern color scheme and variables */\n:root {\n  --primary: #2563eb;\n  --primary-light: #60a5fa;\n  --primary-dark: #1d4ed8;\n  --gray-50: #f9fafb;\n  --gray-100: #f3f4f6;\n  --gray-200: #e5e7eb;\n  --gray-700: #374151;\n  --gray-800: #1f2937;\n  --success: #22c55e;\n  --warning: #f59e0b;\n  --danger: #ef4444;\n}\n\n.dashboard-container {\n  min-height: 100vh;\n  background-color: var(--gray-50);\n  display: flex;\n  flex-direction: column;\n}\n\n/* Header */\n.dashboard-header {\n  background-color: white;\n  padding: 1rem 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid var(--gray-200);\n}\n\n.dashboard-header h1 {\n  font-size: 1.5rem;\n  color: var(--gray-800);\n  margin: 0;\n}\n\n.logo-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #0d47a1;\n  width: 70px;\n  height: 70px;\n  border-radius: 100rem;\n}\n\n.logo {\n  position: relative;\n  top: 2px;\n  width: 60px;\n  object-fit: contain;\n  background: transparent;\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.user-name {\n  color: var(--gray-800);\n  font-weight: 500;\n}\n\n.logout-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  border: 1px solid var(--gray-200);\n  border-radius: 6px;\n  background-color: white;\n  color: var(--gray-700);\n  transition: all 0.2s;\n}\n\n.logout-button:hover {\n  background-color: var(--gray-100);\n}\n\n/* Main Content */\n.dashboard-content {\n  flex: 1;\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 2rem;\n  width: 100%;\n}\n\n/* Welcome Section */\n.welcome-section {\n  background-color: white;\n  border-radius: 8px;\n  padding: 1.5rem;\n  margin-bottom: 2rem;\n  border: 1px solid var(--gray-200);\n}\n\n.welcome-section h2 {\n  color: var(--gray-800);\n  margin-bottom: 0.5rem;\n}\n\n/* Dashboard Sections */\n.dashboard-sections {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 2rem;\n}\n\n.dashboard-section {\n  background-color: white;\n  border-radius: 8px;\n  padding: 1.5rem;\n  border: 1px solid var(--gray-200);\n}\n\n.section-header {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 1.5rem;\n}\n\n.section-icon {\n  color: var(--primary);\n}\n\n.section-header h3 {\n  color: var(--gray-800);\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n/* Action Cards */\n.actions-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1rem;\n}\n\n.action-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 1.5rem;\n  border-radius: 8px;\n  background-color: var(--gray-50);\n  border: 1px solid var(--gray-200);\n  text-decoration: none;\n  color: var(--gray-800);\n  transition: all 0.2s;\n}\n\n.action-card:hover {\n  background-color: var(--gray-100);\n}\n\n.action-card.primary {\n  background-color: var(--primary);\n  color: white;\n  border: none;\n}\n\n.action-card.primary:hover {\n  background-color: var(--primary-dark);\n}\n\n.action-card.raw {\n  background-color: var(--primary-light);\n  color: white;\n  border: none;\n}\n\n.action-card.raw:hover {\n  background-color: var(--primary);\n}\n\n.action-icon {\n  font-size: 1.5rem;\n  margin-bottom: 0.75rem;\n}\n\n/* Messages */\n.success-message {\n  background-color: var(--success);\n  color: white;\n  padding: 0.75rem 1rem;\n  border-radius: 6px;\n  margin-bottom: 1rem;\n}\n\n.low-balance-alert {\n  background-color: var(--danger);\n  color: white;\n  padding: 0.75rem 1rem;\n  border-radius: 6px;\n  margin-bottom: 1rem;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .dashboard-content {\n    padding: 1.5rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .dashboard-sections {\n    grid-template-columns: 1fr;\n  }\n  \n  .actions-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .dashboard-header {\n    padding: 1rem;\n    flex-direction: column;\n    gap: 1rem;\n    text-align: center;\n  }\n  \n  .user-info {\n    flex-direction: column;\n  }\n\n  .logo {\n    height: 40px;\n  }\n}\n\n.rate-info-container {\n  background-color: white;\n  border-radius: 8px;\n  padding: 1.5rem;\n  margin-bottom: 2rem;\n  border: 1px solid var(--gray-200);\n}\n\n.rate-info-content {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.rate-section, .rate-type-section {\n  background-color: var(--gray-50);\n  border: 1px solid var(--gray-200);\n  border-radius: 6px;\n  padding: 1rem;\n}\n\n.rate-display, .rate-type-display {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n}\n\n.rate-display p, .rate-type-display p {\n  margin: 0;\n  font-weight: 500;\n  color: var(--gray-800);\n}\n\n.rate-edit, .rate-type-edit {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.rate-input, .rate-type-select {\n  padding: 0.5rem;\n  border: 1px solid var(--gray-200);\n  border-radius: 4px;\n  width: 120px;\n}\n\n.edit-rate-button, .save-rate-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.edit-rate-button {\n  background-color: white;\n  border: 1px solid var(--primary);\n  color: var(--primary);\n}\n\n.edit-rate-button:hover {\n  background-color: var(--gray-50);\n}\n\n.save-rate-button {\n  background-color: var(--primary);\n  border: none;\n  color: white;\n}\n\n.save-rate-button:hover {\n  background-color: var(--primary-dark);\n}\n\n.save-rate-button:disabled {\n  background-color: var(--gray-200);\n  cursor: not-allowed;\n}\n\n@media (max-width: 768px) {\n  .rate-edit, .rate-type-edit {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .rate-display, .rate-type-display {\n    flex-direction: column;\n    text-align: center;\n    gap: 0.75rem;\n  }\n}\n\n/* Footer */\n.dashboard-footer {\n  text-align: center;\n  padding: 2rem;\n  margin-top: auto;\n  background-color: white;\n  border-top: 1px solid var(--gray-200);\n}\n\n.dashboard-footer p {\n  margin: 0;\n  color: var(--gray-700);\n  font-size: 0.9rem;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .dashboard-footer {\n    padding: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
